export default __webpack_public_path__ + "static/media/token-supply.042133fd.png";